module.exports = __webpack_public_path__ + "static/media/CustomerCube.ed724a74.svg";